<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">1. Dados Gerais do prestador</div>
    <div v-if="!loading">
      <unicom-linha
        style="margin-bottom: 24px"
        :class="
          indexGeral !== Object.entries(objetoInformacoes).length - 1
            ? 'linha-embaixo'
            : ''
        "
        v-for="(infoGeral, indexGeral) in Object.entries(objetoInformacoes)"
        :key="indexGeral"
      >
        <unicom-coluna sm="12" md="6">
          {{ nomeTitulos[indexGeral] }}:
        </unicom-coluna>
        <unicom-coluna sm="12" md="6">
          <div
            class="segunda-cor-fonte medio espacamento-vertical"
            v-for="(info, index) in Object.entries(infoGeral[1])"
            :key="index"
          >
            {{ nomeCampos[infoGeral[0]][index] }}:
            <span class="cor-fonte medio espacamento-horizontal">
              {{ info[1] || " - " }}
            </span>
          </div>
        </unicom-coluna>
      </unicom-linha>
    </div>
    <unicom-spinner
      v-if="loading"
      style="min-height: 76px"
      v-show="loading"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";

export default {
  name: "DadosGeraisPrestador",
  mixins: [DadosGeraisMixin],
  data() {
    return {
      loading: false,
      objetoInformacoes: {
        informacoesBasicas: {
          codigo: 0,
          nome: "",
          genero: "",
          dataNascimento: "",
          documento: "",
          tipo: "",
          codigoConselho: 0,
          descricaoConselhoClasse: ""
        },
        informacoesJuridicas: {
          documento: "",
          cnpjFilial: "",
          nomeFantasia: "",
          incricaoEstadual: "",
          classificacaoEstabelecimento: "",
          cnes: ""
        },
        informacoesContratuais: {
          contratualizacao: "",
          dataInicioContratualizacao: "",
          vinculo: "",
          unimedPrestadora: "",
          nomeUnimedPrestadora: "",
          dataInclusao: "",
          dataExclusao: "",
          dataInicioServico: "",
          dtInauguraRp: "",
          suspensaoTemporaria: "",
          motivoSuspensao: "",
          dataInicioSuspensao: ""
        },
        informacoesServico: {
          disponibilidade: "",
          perfilAssistencial: "",
          nivelAtencao: "",
          tipoPorteHospital: "",
          produto: "",
          rede: "",
          cbo: "",
          titulacao1: "",
          titulacao2: "",
          atualizacao: ""
        },
        indicadoresEstado: {
          exibirNoGuiaMedico: "",
          atendeProntoSocorro: "",
          atendeIntercambio: "",
          enviarWsdTiss: "",
          envioCadu: "",
          telesSaude: ""
        }
      },
      nomeTitulos: [
        "Informações básicas",
        "Informações juridicas",
        "Informações contratuais",
        "Informações do serviço",
        "Indicadores de Estado"
      ],
      nomeCampos: {
        informacoesBasicas: [
          "Código",
          "Nome",
          "Gênero",
          "Data de nascimento",
          "Tipo",
          "Código do Conselho",
          "Descrição do Conselho"
        ],
        informacoesJuridicas: [
          "CPF/CNPJ",
          "Nome Fantasia",
          "Inscrição estadual",
          "Classificação do Estabelecimento",
          "CNES"
        ],
        informacoesContratuais: [
          "Contratualização",
          "Data Inicio de contratualização",
          "Vinculo",
          "Unimed Prestadora",
          "Data da Inclusão",
          "Data da exclusão",
          "Data Inicio do serviço",
          "Data Inauguração RP",
          "Suspensão Temporária",
          "Motivo da Suspensão",
          "Data Início da Suspensão"
        ],
        informacoesServico: [
          "Disponibilidade",
          "Perfil Assistencial",
          "Nível de Atenção",
          "Tipo Porte Hospital",
          "Produto",
          "Rede",
          "CBO",
          "Titulação 1",
          "Titulação 2",
          "Atualização"
        ],
        indicadoresEstado: [
          "Exibir no guia médico?",
          "Atende Urgência/Emergência?",
          "Atende intercâmbio?",
          "Enviar WSD-TISS?",
          "Envio CADU?",
          "Atende Telessaúde?"
        ]
      }
    };
  },
  methods: {
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getDadosGeraisPrestador(this.idRnpPrestador)
          .then(res => {
            let objetoDadosGeraisTemp = res.data;

            Object.keys(objetoDadosGeraisTemp).forEach(e => {
              if (objetoDadosGeraisTemp[e] === null)
                objetoDadosGeraisTemp[e] = undefined;
            });

            let {
              atualizacao,
              cbo,
              cdConselho: codigoConselho,
              descricaoConselhoClasse: descricaoConselhoClasse,
              classificacaoEstabelecimento: {
                descricao: descricaoEstabelecimento
              } = { descricao: " - " },
              cnes,
              codigo,
              contratualizacao: { descricao: descricaoContratualizacao } = {
                descricao: " - "
              },
              cpfCnpj: documento,
              disponibilidade: { descricao: descricaoDisponibilidade } = {
                descricao: " - "
              },
              dtExclusao: dataExclusao,
              dtInclusao: dataInclusao,
              dtInicioContratualizacao: dataInicioContratualizacao,
              dtInicioServico: dataInicioServico,
              dtInauguraRp,
              dtNascimento: dataNascimento,
              genero,
              inscricaoEst: incricaoEstadual,
              nome,
              nomeFantasia,
              perfilAssistencial,
              nivelAtencao: { descricao: descricaoNivelAtencao } = {
                descricao: " - "
              },
              tipoPorteHospital: { descricao: descricaoTipoPorteHospital } = {
                descricao: " - "
              },
              idSuspTempHosp: { descricao: descricaoSuspensaoTemporaria } = {
                descricao: " - "
              },
              motivoSuspHosp: { descricao: descricaoMotivoSuspensao } = {
                descricao: " - "
              },
              dtIniSuspHosp,
              produto: { descricao: descricaoProduto } = {
                descricao: " - "
              },
              rede: { descricao: descricaoRede } = {
                descricao: " - "
              },
              tipo,
              titulacao1,
              titulacao2,
              unimedPrestadora,
              nomeUnimedPrestadora,
              vinculo,
              exibirNoGuiaMedico: { descricao: descricaoexibirNoGuiaMedico } = {
                descricao: " - "
              },
              atendeProntoSocorro: {
                descricao: descricaoatendeProntoSocorro
              } = {
                descricao: " - "
              },
              atendeIntercambio: { descricao: descricaoatendeIntercambio } = {
                descricao: " - "
              },
              enviarWsdTiss: { descricao: descricaoenviarWsdTiss } = {
                descricao: " - "
              },
              envioCadu: { descricao: descricaoenvioCadu } = {
                descricao: " - "
              },
              telesSaude: { descricao: descricaotelesSaude } = {
                descricao: " - "
              },
              nrCns,
              cnpjHospRef
            } = res.data;

            this.objetoInformacoes.informacoesBasicas = {
              codigo,
              nome,
              genero,
              dataNascimento: this.$helpers.formatadorDataSafe(dataNascimento),
              tipo,
              codigoConselho,
              descricaoConselhoClasse
            };

            const temCns = !!nrCns;

            const temCnpjHospRef = !!cnpjHospRef;

            this.objetoInformacoes.informacoesJuridicas = {
              documento,
              nomeFantasia,
              incricaoEstadual,
              classificacaoEstabelecimento: descricaoEstabelecimento,
              cnes,
              ...(temCns && { nrCns }),
              ...(temCnpjHospRef && { cnpjHospRef })
            };

            if (temCns) {
              this.nomeCampos.informacoesJuridicas = [
                ...this.nomeCampos.informacoesJuridicas,
                "CNS"
              ];
            }

            if (temCnpjHospRef) {
              this.nomeCampos.informacoesJuridicas = [
                ...this.nomeCampos.informacoesJuridicas,
                "CNPJ Hospital Referência"
              ];
            }

            this.objetoInformacoes.informacoesContratuais = {
              contratualizacao: descricaoContratualizacao,
              dataInicioContratualizacao: this.$helpers.formatadorDataSafe(
                dataInicioContratualizacao
              ),
              vinculo,
              nomeUnimedPrestadora:
                unimedPrestadora != 0
                  ? unimedPrestadora + " - " + nomeUnimedPrestadora
                  : "-",
              dataInclusao: this.$helpers.formatadorDataSafe(dataInclusao),
              dataExclusao: this.$helpers.formatadorDataSafe(dataExclusao),
              dataInicioServico: this.$helpers.formatadorDataSafe(
                dataInicioServico
              ),
              dtInauguraRp: this.$helpers.formatadorDataSafe(dtInauguraRp),
              suspensaoTemporaria: descricaoSuspensaoTemporaria,
              motivoSuspensao: descricaoMotivoSuspensao,
              dataInicioSuspensao: this.$helpers.formatadorDataSafe(
                dtIniSuspHosp
              )
            };

            this.objetoInformacoes.informacoesServico = {
              disponibilidade: descricaoDisponibilidade,
              perfilAssistencial,
              nivelAtencao: descricaoNivelAtencao,
              tipoPorteHospital: descricaoTipoPorteHospital,
              produto: descricaoProduto,
              rede: descricaoRede,
              cbo,
              titulacao1,
              titulacao2,
              atualizacao: this.$helpers.formatadorDataSafe(atualizacao)
            };

            this.objetoInformacoes.indicadoresEstado = {
              exibirNoGuiaMedico: descricaoexibirNoGuiaMedico,
              atendeProntoSocorro: descricaoatendeProntoSocorro,
              atendeIntercambio: descricaoatendeIntercambio,
              enviarWsdTiss: descricaoenviarWsdTiss,
              envioCadu: descricaoenvioCadu,
              telesSaude: descricaotelesSaude
            };

            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.espacamento-horizontal {
  padding-left: 8px;
}

.espacamento-vertical {
  padding-bottom: 16px;

  &:last-child {
    padding-bottom: 0px;
  }
}
</style>
